export const waitForSwiper = (resolve, timeout = 7000) => {
    const start = Date.now();

    function check() {
        if (typeof window.Swiper !== 'undefined') {
            if (typeof resolve === 'function') {
                resolve(window.Swiper);
            }
            return;
        }

        if (Date.now() - start > timeout) {
            console.error('Failed to load swiper');
            return;
        }

        setTimeout(check, 50);
    }

    check();
};

export default {
    waitForSwiper,
};
